import ExperienceItem from './experience-item.js';
import SectionHeading from '../section-heading.js';
import { useLanguage } from '../language-context.js';
import content from '../content.js';

const BlockExperience = () => {
  const { lang } = useLanguage();
  const t = content[lang].experience;

  return (
    <section className="experience" id="experience">
      <SectionHeading number={t.number} title={t.title} />
      <div className="timeline">
        {t.timeline.map((entry) => (
          <ExperienceItem key={entry.company + entry.period} entry={entry} />
        ))}
      </div>
    </section>
  );
}

export default BlockExperience;
